export enum DeleteAccountMessages {
  stepOne = "deleteAccount.stepOne",
  description = "deleteAccount.Description",
  stepTwo = "deleteAccount.stepTwo",
  stepThree = "deleteAccount.stepThree",
  deleteButton = "deleteAccount.deleteButton",
  checkConfirmDeletion = "deleteAccount.checkConfirmDeletion",
  deleteAccountFailed = "deleteAccount.deleteAccountFailed"
}

export interface TranslationDeleteAccountMessages {
  [DeleteAccountMessages.stepOne]: string;
  [DeleteAccountMessages.description]: string;
  [DeleteAccountMessages.stepTwo]: string;
  [DeleteAccountMessages.stepThree]: string;
  [DeleteAccountMessages.deleteButton]: string;
  [DeleteAccountMessages.checkConfirmDeletion]: string;
  [DeleteAccountMessages.deleteAccountFailed]: string;
}